/* Bestsellers carousel: plain flex track + native scroll-snap + scrollBy().
   No Swiper, no slick, no autoplay, no loop. */
(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-up-bestsellers-track]');
    if (!track || track.hasAttribute('data-up-bestsellers-ready')) return;
    track.setAttribute('data-up-bestsellers-ready', 'true');

    var prevButtons = root.querySelectorAll('[data-up-bestsellers-prev]');
    var nextButtons = root.querySelectorAll('[data-up-bestsellers-next]');

    function step() {
      var card = track.querySelector('.up-bestsellers__card');
      if (!card) return track.clientWidth;
      var trackStyle = getComputedStyle(track);
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function setButtonState(btn, disabled) {
      // The reference never disables these arrows or greys them out: prev
      // always shows the pale surface and next always shows the gold sweep.
      // Keep the semantics for assistive tech, but not the visual state.
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    function updateArrows() {
      // Mobile uses a negative-margin/padding bleed on the track (see CSS),
      // so the browser's resting scrollLeft at the true "start" equals the
      // inline padding, not 0. Use that as the atStart threshold.
      var trackStyle = getComputedStyle(track);
      var startPad = parseFloat(trackStyle.paddingLeft) || 0;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= startPad + 1;
      var atEnd = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;

      prevButtons.forEach(function (btn) {
        setButtonState(btn, atStart);
      });
      nextButtons.forEach(function (btn) {
        setButtonState(btn, atEnd);
      });
    }

    prevButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    });

    nextButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateArrows();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function init() {
    document.querySelectorAll('.up-bestsellers').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector ? event.target.querySelector('.up-bestsellers') : null;
    if (section) initCarousel(section);
  });
})();
